import { Navigate, RouteProps, useLocation } from "react-router-dom";
import { useAbility } from "../../hooks/useAbilityRules";
import { useGetCompanyAdmins } from "../../../pages/Profile/pages/Team/hooks/useGetCompanyAdmin";
import { useMe } from "../../hooks/useMe";
import { useIsGuest } from "../../hooks/useIsGuest";

type Actions = "create" | "readOne" | "readAll" | "update" | "delete";
interface PrivateRouteProps extends RouteProps {
	allowedIf?: { can: Actions; model: string };
	redirectTo?: string;
	guestNotAllowed?: boolean;
}

export function ABACRoute({ children, allowedIf, redirectTo, guestNotAllowed, ...rest }: PrivateRouteProps): any {
	const { ability } = useAbility();

	const location = useLocation();

	const { isGuest } = useIsGuest();

	const canDoIt = allowedIf ? ability.can(allowedIf?.can, allowedIf?.model) : null;
	const needEmailVerification = ability.can("manage", "EmailVerification");
	const needTwoFactor = ability.can("manage", "2FA");

	const isLoggedIn = ability.can("readOne", "User") && !needEmailVerification;

	return canDoIt && (!guestNotAllowed || !isGuest) ? (
		children
	) : (
		<Navigate
			to={
				redirectTo ||
				(needEmailVerification ? "/email-confirmation" : isLoggedIn ? "/" : needTwoFactor ? "/login/two-fa" : "/login")
			}
			state={{ from: location }}
		/>
	);
}
